// app/providers.tsx
'use client';
import BuildTimeComment from "@app-sw/components/Utility/BuildTimeComment";
import { ChakraProvider } from '@chakra-ui/react';
import { ishaTheme } from './theme.sw';
export function Providers({ children }) {
  return (
    <>
      <ChakraProvider resetCSS theme={ishaTheme}>
        {children}
      </ChakraProvider>
      <BuildTimeComment />
    </>
  );
}
